module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-view"
  }, [_c('div', {
    staticClass: "upload-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onUploading),
      expression: "!onUploading"
    }],
    staticClass: "before-upload"
  }, [_c('div', {
    staticClass: "upload-image img"
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('supportFormat')))]), _vm._v(" "), _c('div', {
    staticClass: "uploader-btn"
  }, [(_vm.uploader === 'qiniu') ? _c('qiniuuploader', {
    attrs: {
      "btnType": "primary",
      "btnPlain": false,
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : (_vm.uploader === 'nginx') ? _c('nginxuploader', {
    attrs: {
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : (_vm.uploader === 'ss') ? _c('ssuploader', {
    attrs: {
      "btnType": "primary",
      "btnPlain": false,
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onUploading),
      expression: "onUploading"
    }],
    staticClass: "uploading"
  }, [_c('div', {
    staticClass: "upload-image img"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-area"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', [_vm._v(_vm._s(_vm.filename))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v(_vm._s(_vm.sizeReadable(_vm.filesize)))])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.progress
    }
  })], 1), _vm._v(" "), (!_vm.tbcMode) ? _c('div', {
    staticClass: "uploading-hint"
  }, [_vm._m(0)]) : _vm._e()])]), _vm._v(" "), (!_vm.tbcMode) ? _c('div', {
    staticClass: "tempaltes-frame"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/http://h5.ppj.io/yhiCzynw/index.html?v=10)'
    })
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hint"
  }, [_vm._v("上传遇到问题？请更换\n          "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://ppj.io/docs/#/browsers",
      "target": "_blank"
    }
  }, [_vm._v("\n              其他浏览器")]), _vm._v(" 重试，或\n          "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://ppj.io/docs/#/feedback",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hint"
  }, [_vm._v("PPT也能做竖版？"), _c('br'), _vm._v("1分钟成为H5达人！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_c('a', {
    staticClass: "text-btn template",
    attrs: {
      "href": "https://pan.baidu.com/s/1gfN4jJl",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("福利！海量H5模板下载")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c832e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/upload/index.vue
// module id = 916
// module chunks = 3